
export const inactivityService = (setfunction) => { 
       
    let inactivityTimer;

    const redirectToLogin = () => {
        setfunction(false);
    };

    // Reset Inactivity Time
    const resetInactivityTimer = () => {
        clearTimeout(inactivityTimer); 
        inactivityTimer = setTimeout(redirectToLogin, 15 * 60 * 1000); 
        // 5mins 
    };

    // Event listeners to track user activity
    const activityEvents = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    activityEvents.forEach(event => {
        document.addEventListener(event, resetInactivityTimer);
    });

    // Initialize the timer on Call.
        resetInactivityTimer();
            
}